import { FC } from 'react';

import { Tabs, Tab } from '@mui/material';

import { TelegramChatSettingsTabsEnum } from '../constants';

import { TelegramChatSettingsPageTabsProps } from './types';

import styles from './TelegramChatSettingsPageTabs.module.css';

const { tabsContainer } = styles;

export const TelegramChatSettingsPageTabs: FC<TelegramChatSettingsPageTabsProps> = ({ currentTab, setTab }) => {
  const tabs = Object.values(TelegramChatSettingsTabsEnum);

  return (
    <Tabs className={tabsContainer} textColor="inherit" value={currentTab} variant="scrollable" scrollButtons="auto">
      {tabs.map((tab: TelegramChatSettingsTabsEnum) => {
        const onClick = () => setTab(tab);

        return <Tab onClick={onClick} label={tab} value={tab} key={tab} />;
      })}
    </Tabs>
  );
};
